var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.33333C4 8.97971 4.14048 8.64057 4.39052 8.39052C4.64057 8.14048 4.97971 8 5.33333 8H26.6667C27.0203 8 27.3594 8.14048 27.6095 8.39052C27.8595 8.64057 28 8.97971 28 9.33333C28 9.68696 27.8595 10.0261 27.6095 10.2761C27.3594 10.5262 27.0203 10.6667 26.6667 10.6667H5.33333C4.97971 10.6667 4.64057 10.5262 4.39052 10.2761C4.14048 10.0261 4 9.68696 4 9.33333ZM6.66667 15.3333C6.66667 14.9797 6.80714 14.6406 7.05719 14.3905C7.30724 14.1405 7.64638 14 8 14H24C24.3536 14 24.6928 14.1405 24.9428 14.3905C25.1929 14.6406 25.3333 14.9797 25.3333 15.3333C25.3333 15.687 25.1929 16.0261 24.9428 16.2761C24.6928 16.5262 24.3536 16.6667 24 16.6667H8C7.64638 16.6667 7.30724 16.5262 7.05719 16.2761C6.80714 16.0261 6.66667 15.687 6.66667 15.3333ZM10.6667 21.3333C10.6667 20.9797 10.8071 20.6406 11.0572 20.3905C11.3072 20.1405 11.6464 20 12 20H20C20.3536 20 20.6928 20.1405 20.9428 20.3905C21.1929 20.6406 21.3333 20.9797 21.3333 21.3333C21.3333 21.687 21.1929 22.0261 20.9428 22.2761C20.6928 22.5262 20.3536 22.6667 20 22.6667H12C11.6464 22.6667 11.3072 22.5262 11.0572 22.2761C10.8071 22.0261 10.6667 21.687 10.6667 21.3333Z",
    fill: "#10100F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSvg);
export default __webpack_public_path__ + "static/media/filterSvg.6536a72e669994d3c44986e2923be924.svg";
export { ForwardRef as ReactComponent };